import {Component, OnInit} from '@angular/core';
import {environment} from "../../../environments/environment";
import {GeneralConfigService} from "../../@core/services/config/general-config/general-config.service";

@Component({
    selector: 'app-footer-custom',
    templateUrl: './footer-custom.component.html',
    styleUrls: ['./footer-custom.component.scss'],
    standalone: false
})
export class FooterCustomComponent implements OnInit{

  currYear = new Date().getFullYear();
  version = environment.version;

  impressumUrl: string = '';
  datenschutzUrl: string = '';

  constructor(
    private readonly generalConfigService: GeneralConfigService
  ) {
  }

  ngOnInit() {
    this.generalConfigService.getUrlConfig()
      .subscribe((urlConfig) => {
        this.impressumUrl = urlConfig.impressumUrl;
        this.datenschutzUrl = urlConfig.datenschutzUrl;
    });
  }

  navigateToImpressum() {
    window.open(
      this.impressumUrl,
      '_blank'
    );
  }

  navigateToDatenschutz() {
    window.open(
      this.datenschutzUrl,
      '_blank'
    );
  }
}
